import { call, put, takeLatest } from 'redux-saga/effects';

import { getInsuranceTaxes } from '../../services/API';
import {
  actionTypes,
  requestFailure,
  requestSuccess,
} from 'modules/UserIncomes/redux/insuranceTaxes/actions';

function* getData(action) {
  const response = yield call(getInsuranceTaxes, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* insuranceTaxesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
}
